import { defineComponent as _defineComponent } from 'vue'
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgReload from "@/assets/icons/reload-double.svg";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import { computed } from "vue";

interface Props {
    disabled?: boolean
    disableText?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReloadButton',
  props: {
    disabled: { type: Boolean },
    disableText: null
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    disabled?: boolean
    disableText?: string
}




const isShowTooltip = computed(() => props.disabled && props.disableText);

return { __sfc: true,props, emits, isShowTooltip, BaseButtonV2, SvgReload, BaseTooltip }
}

})